/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import * as CONSTANTS from "../constants/table";

export const useTable = () => {
  const getCellDisplay = (keyLookup: any, row: any) => {
    const { key: lookupKey, translateKeyPrefix } = keyLookup;
    //two property path
    const multiples = lookupKey.split(CONSTANTS.PLUS);
    const displayValue = multiples.reduce((o: string, k: string) => {
      // if v === -1, retrive the last element of the array
      const _value = k.split(CONSTANTS.DOT).reduce((r: any, v: string) => {
        return r && (v === "-1" && r.length ? r[r.length - 1] : r[v]);
      }, row);
      const value = _value ? _value : _value === 0 ? "0" : "";
      if (o) {
        return `${o} ${value}`;
      } else {
        return value;
      }
    }, "");
    if (translateKeyPrefix && displayValue) {
      return `${translateKeyPrefix}${displayValue}`;
    } else {
      return displayValue;
    }
  };

  return {
    getCellDisplay,
  };
};
